import React, {useReducer, useState, useLayoutEffect} from 'react'
import {listify} from "radash";

const passwordAndConfirmPreReducer = (state, action) => {


    switch (action.name) {
        case "init": {
            return {
                ...state,
                password: '',
                passwordConfirm: ''
            }
        }

        case "updatePassword": {

            const password = action.password
            return {
                ...state,
                password: password,
                tooShort: password.length < state.minLength,
                noDigit: !/\d/.test(password),
                noLowercase: !/[a-z]/.test(password),
                noUpercase: !/[A-Z]/.test(password),
                noSpecialCaracter: !/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
            }
        }
        case "updatePasswordConfirm": {
            return {
                ...state,
                passwordConfirm: action.passwordConfirm
            }
        }
        default:
            throw Error(`unknown action : '${action.name}'`)
    }
}

export const passwordAndConfirmReducer = (state, action) => {

    const nextState = passwordAndConfirmPreReducer(state, action)

    const pwStrengthWarnings = {
      tooShort: nextState.tooShort,
      noDigit: nextState.noDigit,
      noLowercase: nextState.noLowercase,
      noUpercase: nextState.noUpercase,
      noSpecialCaracter: nextState.noSpecialCaracter
    }

    const pkStrengthMessages = {
      tooShort: `at least ${state.minLength} characters long`,
      noDigit: 'at least one digit',
      noLowercase: 'at least one lowercase character',
      noUpercase: 'at least one uppercase character',
      noSpecialCaracter: 'at least one special character (ex: $,-,!,@, etc.)'
    }


    const problemList =
      listify(pwStrengthWarnings, (k, v) => v ? pkStrengthMessages[k]: null).filter(i=>i)

    const passwordStrengthWeak = problemList.length > 0

    const warnFieldsDiffer = (nextState.passwordConfirm !== "") && nextState.passwordConfirm !== nextState.password

    const canReset = !(
        passwordStrengthWeak || warnFieldsDiffer || problemList.length > 0 ||
            nextState.password === ""
    )

    return {
        ...nextState,
        problemList,
        passwordStrengthWeak,
        warnFieldsDiffer,
        canReset
    }
}



export const usePasswordAndConfirmFields = minLength => {

    const [passwordAndConfirmView, passwordAndConfirmDispatch] = useReducer(
        passwordAndConfirmReducer, null,
        () => passwordAndConfirmReducer({minLength}, {name: 'init'})
    )

    return {
        ...passwordAndConfirmView,
        setPassword: password => passwordAndConfirmDispatch({name: 'updatePassword', password}),
        setPasswordConfirm: passwordConfirm => passwordAndConfirmDispatch({name: 'updatePasswordConfirm', passwordConfirm})
    }
}



export const useWindowSize = () => {

  const [size, setSize] = useState([0, 0])

  useLayoutEffect(() => {
        function updateSize() {
            console.log("WR")
            setSize([window.innerWidth, window.innerHeight])
        }
        window.addEventListener('resize', updateSize)
        updateSize()
        return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size;
}